import { createSlice } from '@reduxjs/toolkit'

const dcContingencySlice = createSlice({
  name: 'dcContingency',
  initialState: {
    firstLoad: false,
    apiLoading: false,
    all: [],
    format: [],
    displayList: [],
    downloadLoader: false,
    uploadLoader: false,
  },
  reducers: {
    setLoader(
      state,
      action
    ) {
      state.apiLoading = action.payload
    },
    setFirstLoad(
      state,
      action
    ) {
      state.firstLoad = action.payload
    },
    setAllData(
      state,
      action
    ) {
      state.all = action.payload
    },
    setFormatData(
      state,
      action
    ) {
      state.format = action.payload
    },
    setDisplayList(state, action) {
      state.displayList = action.payload
    },
    setDownloadLoader(state, action) {
      state.downloadLoader = action.payload
    },
    setUploadLoader(state, action) {
      state.uploadLoader = action.payload
    },
  },
})

export const {
  setLoader,
  setFirstLoad,
  setAllData,
  setFormatData,
  setDisplayList,
  setDownloadLoader,
  setUploadLoader,
} = dcContingencySlice.actions

export default dcContingencySlice.reducer
